import $ from 'jquery';
import Foundation from 'foundation-sites';

export class Confirmation {
  constructor(opts = null) {
    this.options = Object.assign({
      content: '',
      header: 'Potwierdź dzialanie',
      size: 'small',
      buttons: null
    }, opts);
    this.wrapper = $('<div data-reveal />').addClass('reveal').addClass(this.options.size)
      .append($('<h1 class="app-modal-header" />').text(this.options.header))
      .append($('<div />').text(this.options.content));
    if (this.options.buttons) {
      const buttonsWrapper = $('<div />').addClass('app-modal-buttons');
      for (let i in this.options.buttons) {
        const button = $('<button />')
          .addClass('button')
          .click(this.options.buttons[i].onclick)
          .text(this.options.buttons[i].label);
        if (this.options.buttons[i].class) {
          button.addClass(this.options.buttons[i].class);
        }
        buttonsWrapper.append(button);
      }
      this.wrapper.append(buttonsWrapper);
    }
    this.wrapper
      .append($('<button data-close type="button" />').addClass('close-button').html('<span aria-hidden="true">&times;</span>'));
    this.modal = new Foundation.Reveal(this.wrapper);
    this.modal.open();
  }

  close() {
    this.modal.destroy();
    this.wrapper.remove();
  }
}

